import { ResponsivePie } from "@nivo/pie";
import useApp from "../../hooks/useApp";
import { Chart } from "../../assets/svgs";
import "./styles.scss";

const ProgressCircleChart = ({  chartText }) => {
  const { eligibilityPolicyData } = useApp();
  
  return (
    <div className="progress-circle-chart">
      <ResponsivePie
        data={eligibilityPolicyData ?? []}
        startAngle={-90}
        endAngle={90}
        innerRadius={0.75}
        padAngle={1.5}
        enableArcLinkLabels={false}
        enableArcLabels={false}
        colors={eligibilityChart => eligibilityChart.data.color}
        tooltip={() => null}
      />
      <img src={Chart} alt="dotted-line" className="chort-dotted-line" />
      <p className="chart-text">{chartText}</p>
    </div>
  );
};

export default ProgressCircleChart;
